import script from "./CounterpartyInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CounterpartyInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./CounterpartyInfoModal.vue?vue&type=style&index=0&id=4bd35a93&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd35a93"]])

export default __exports__